import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const faqs = [
  {
    question: "How much does AI video creation cost?",
    answer: "Our pricing is volume-based and significantly more affordable than traditional production. We offer packages starting from single videos to monthly retainers for high-volume content needs. Get a quote for a custom breakdown."
  },
  {
    question: "What is the typical delivery time?",
    answer: "Standard projects are delivered within 24–72 hours. For high-volume batches (20+ videos), we provide a customized timeline, usually within 5-7 working days."
  },
  {
    question: "Do I own the commercial usage rights?",
    answer: "Yes, 100%. Upon delivery and final payment, you own full commercial rights to all video assets created for your brand."
  },
  {
    question: "Can you use specific AI avatars or voiceovers?",
    answer: "Absolutely. We can use custom AI avatars, clone your own voice, or use professional studio-quality AI voices in over 40+ languages."
  },
  {
    question: "Are revisions included?",
    answer: "Yes, every project includes a standard round of revisions to ensure the final output perfectly matches your brand guidelines and expectations."
  }
];

const VideoFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">FAQ</h2>
          <p className="text-4xl font-extrabold text-slate-900">Common Questions</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-slate-100">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 flex items-center justify-between text-left group"
              >
                <span className="text-xl font-bold text-slate-900 group-hover:text-emerald-600 transition-colors">
                  {faq.question}
                </span>
                <SafeIcon 
                  icon={openIndex === index ? FiMinus : FiPlus} 
                  className={`text-2xl ${openIndex === index ? 'text-emerald-600' : 'text-slate-400'}`} 
                />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 text-slate-600 font-medium leading-relaxed">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoFAQ;
